
import { isObjectMoveable, setIsObjectMoveable } from './is-object.js';

export class ObjectPropertyHandler {

	static moveable = new ObjectPropertyHandler( obj => obj.uuid, obj => isObjectMoveable( obj ), (obj, value) => setIsObjectMoveable( obj, value ));

    keySolver;
    getter;
    setter;
    
    handlers = {}
    
    constructor( keySolver, getter, setter, filterFn ) {
        this.keySolver = keySolver;
        this.getter    = getter;
        this.setter    = setter;
        this.filterFn  = filterFn;
    }

    of( object ) {
        
        if (this.filterFn && !this.filterFn( object )) return;
        
        let key = this.keySolver( object );

        if (!this.handlers[ key ]) {

            this.handlers[ key ] = (( handler, object ) => {
    
                Object.defineProperty( handler, "value", {
                    get: () => {
                        return this.getter( object );
                    },
                    set: value => {
                        this.setter( object, value );
                    },
					enumerable: true
                });
                
                return handler;

            })({ }, object );
        }
        
        return this.handlers[ key ];
    }
}


window.ObjectPropertyHandler = ObjectPropertyHandler;
